import React from "react";
import CustomInput from "../components/CustomInput";
import axios from "axios";
import { base_url } from "../utils/baseUrl";



const submitHandler = async (e) => {
  e.preventDefault();
  const res = await axios.post(`${base_url}/users/forget-password`, {
    password: e.target.pass.value,
    confirmPassword: e.target.confirmpass.value
  })
  console.log(res);
}

const Resetpassword = () => {
  return (
    <div className="py-5" style={{ background: "#ffd333", minHeight: "100vh" }}>
      <br />
      <br />
      <br />
      <br />
      <br />
      <div className="my-5 w-25 bg-white rounded-3 mx-auto p-4">
        <h3 className="text-center title"> Reset Password</h3>
        <p className="text-center">Please Enter your new password.</p>
        <form action="" onSubmit={submitHandler}>
          <CustomInput type="password" label="New Password" id="pass" />
          <CustomInput
            type="password"
            label="Confirm Password"
            id="confirmpass"
          />

          <button
            className="border-0 px-3 py-2 text-white fw-bold w-100"
            style={{ background: "#ffd333" }}
            type="submit"
          >
            Reset Password
          </button>
        </form>
      </div>
    </div>
  );
};

export default Resetpassword;
